import React from 'react'
import { I18NText, Model } from 'src/types'

export const useConfirm = () => {
  const [isConfirmOpen, setIsConfirmOpen] = React.useState(false)
  const handleConfirmOpen = () => {
    setIsConfirmOpen(true)
  }
  const handleConfirmClose = () => {
    setIsConfirmOpen(false)
  }
  return {
    isConfirmOpen,
    setIsConfirmOpen,
    handleConfirmOpen,
    handleConfirmClose
  }
}

export const useSelectBaseModel = () => {
  const [selectedModel, setSelectedModel] = React.useState<Model>()
  const handleBaseModel = (model: Model) => setSelectedModel(model)
  return {
    selectedModel,
    handleBaseModel
  }
}

export const startConfirmMessageGenerator = (selectedModel: Model, isEn: boolean, t: I18NText): string => {
  const message = isEn
    ? `${t.CONFIRM_START_SIMULATION}${selectedModel?.productNumber}`
    : `${selectedModel?.productNumber}${t.CONFIRM_START_SIMULATION}`
  return message
}
